import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MessageIcon from "../../../../components/Icons/Icons";
import { decodedText } from "../../../../helpers/utils";
import SweetAlert from '../../../../components/SweetAlert/SweetAlert';
import Swal from 'sweetalert2';
import { removePinMessage } from "../../../../store/slices/chatSlice";

const PinnedMessage = () => {
    const dispatch = useDispatch();
    const { pinnedMessage, isLoading } = useSelector((state) => state.chat);

    if (!pinnedMessage) return null;

    const unPinTextMessage = () => {
        SweetAlert({
            title: "Do you want to unpin this message?",
            text: decodedText(pinnedMessage?.attributes?.message?.sanitizedText),
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(removePinMessage(pinnedMessage.id)).unwrap();
            },
        });
    };

    return (
        <div className="status-box shadow border pinned-message-container">
            <div className="pinned-content d-flex">
                <MessageIcon />
                <div className="status-text">
                    <small>{pinnedMessage?.attributes?.message?.user?.name} </small> <br />
                    <span className="text-uniform">
                        {decodedText(pinnedMessage?.attributes?.message?.sanitizedText)}
                    </span>
                </div>

            </div>
            <div className="status-label">
                <button
                    className="btn btn-outline-danger"
                    onClick={unPinTextMessage}
                    aria-label="Unpin message"
                    disabled={isLoading}
                >
                    Remove Pin
                </button>
            </div>

        </div>
    )
};

export default PinnedMessage;